import React from 'react';
import { Card } from '../components/ui/Card';
import { formatCurrency } from '../utils/calculations';
export function BalanceSheet() {
  const balanceSheetData = {
    assets: {
      current: [{
        name: 'Cash and Cash Equivalents',
        amount: 125000
      }, {
        name: 'Accounts Receivable',
        amount: 45000
      }, {
        name: 'Inventory',
        amount: 18000
      }, {
        name: 'Prepaid Expenses',
        amount: 5000
      }],
      fixed: [{
        name: 'Property and Equipment',
        amount: 150000
      }, {
        name: 'Vehicles',
        amount: 45000
      }, {
        name: 'Less: Accumulated Depreciation',
        amount: -35000
      }]
    },
    liabilities: {
      current: [{
        name: 'Accounts Payable',
        amount: 28000
      }, {
        name: 'Credit Cards',
        amount: 12000
      }, {
        name: 'Current Portion of Long-term Debt',
        amount: 15000
      }, {
        name: 'Accrued Expenses',
        amount: 8000
      }],
      longTerm: [{
        name: 'Long-term Debt',
        amount: 85000
      }, {
        name: 'Equipment Loans',
        amount: 25000
      }]
    }
  };
  const totalCurrentAssets = balanceSheetData.assets.current.reduce((sum, item) => sum + item.amount, 0);
  const totalFixedAssets = balanceSheetData.assets.fixed.reduce((sum, item) => sum + item.amount, 0);
  const totalAssets = totalCurrentAssets + totalFixedAssets;
  const totalCurrentLiabilities = balanceSheetData.liabilities.current.reduce((sum, item) => sum + item.amount, 0);
  const totalLongTermLiabilities = balanceSheetData.liabilities.longTerm.reduce((sum, item) => sum + item.amount, 0);
  const totalLiabilities = totalCurrentLiabilities + totalLongTermLiabilities;
  const totalEquity = totalAssets - totalLiabilities;
  return <div className="space-y-6" data-id="element-391">
      <div data-id="element-392">
        <h1 className="text-2xl font-bold text-gray-900 mb-2" data-id="element-393">Balance Sheet</h1>
        <p className="text-sm text-gray-600" data-id="element-394">
          As of{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>
      </div>

      {/* Assets */}
      <Card data-id="element-395">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-396">Assets</h2>

        {/* Current Assets */}
        <div className="mb-6" data-id="element-397">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-398">
            Current Assets
          </h3>
          <div className="space-y-2" data-id="element-399">
            {balanceSheetData.assets.current.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-400">
                <span className="text-gray-700" data-id="element-401">{item.name}</span>
                <span className="font-medium text-gray-900" data-id="element-402">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-403">
              <span className="text-gray-900" data-id="element-404">Total Current Assets</span>
              <span className="text-gray-900" data-id="element-405">
                {formatCurrency(totalCurrentAssets)}
              </span>
            </div>
          </div>
        </div>

        {/* Fixed Assets */}
        <div className="mb-4" data-id="element-406">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-407">
            Fixed Assets
          </h3>
          <div className="space-y-2" data-id="element-408">
            {balanceSheetData.assets.fixed.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-409">
                <span className={item.amount < 0 ? 'text-gray-600 pl-4' : 'text-gray-700'} data-id="element-410">
                  {item.name}
                </span>
                <span className={`font-medium ${item.amount < 0 ? 'text-gray-600' : 'text-gray-900'}`} data-id="element-411">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-412">
              <span className="text-gray-900" data-id="element-413">Total Fixed Assets</span>
              <span className="text-gray-900" data-id="element-414">
                {formatCurrency(totalFixedAssets)}
              </span>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t-2 border-gray-300" data-id="element-415">
          <div className="flex justify-between items-center" data-id="element-416">
            <span className="text-lg font-bold text-gray-900" data-id="element-417">
              Total Assets
            </span>
            <span className="text-lg font-bold text-blue-600" data-id="element-418">
              {formatCurrency(totalAssets)}
            </span>
          </div>
        </div>
      </Card>

      {/* Liabilities */}
      <Card data-id="element-419">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-420">Liabilities</h2>

        {/* Current Liabilities */}
        <div className="mb-6" data-id="element-421">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-422">
            Current Liabilities
          </h3>
          <div className="space-y-2" data-id="element-423">
            {balanceSheetData.liabilities.current.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-424">
                <span className="text-gray-700" data-id="element-425">{item.name}</span>
                <span className="font-medium text-gray-900" data-id="element-426">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-427">
              <span className="text-gray-900" data-id="element-428">Total Current Liabilities</span>
              <span className="text-gray-900" data-id="element-429">
                {formatCurrency(totalCurrentLiabilities)}
              </span>
            </div>
          </div>
        </div>

        {/* Long-term Liabilities */}
        <div className="mb-4" data-id="element-430">
          <h3 className="text-sm font-semibold text-gray-700 uppercase tracking-wide mb-3" data-id="element-431">
            Long-term Liabilities
          </h3>
          <div className="space-y-2" data-id="element-432">
            {balanceSheetData.liabilities.longTerm.map((item, index) => <div key={index} className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-433">
                <span className="text-gray-700" data-id="element-434">{item.name}</span>
                <span className="font-medium text-gray-900" data-id="element-435">
                  {formatCurrency(item.amount)}
                </span>
              </div>)}
            <div className="flex justify-between items-center py-2 font-semibold" data-id="element-436">
              <span className="text-gray-900" data-id="element-437">Total Long-term Liabilities</span>
              <span className="text-gray-900" data-id="element-438">
                {formatCurrency(totalLongTermLiabilities)}
              </span>
            </div>
          </div>
        </div>

        <div className="pt-4 border-t-2 border-gray-300" data-id="element-439">
          <div className="flex justify-between items-center" data-id="element-440">
            <span className="text-lg font-bold text-gray-900" data-id="element-441">
              Total Liabilities
            </span>
            <span className="text-lg font-bold text-red-600" data-id="element-442">
              {formatCurrency(totalLiabilities)}
            </span>
          </div>
        </div>
      </Card>

      {/* Equity */}
      <Card data-id="element-443">
        <h2 className="text-xl font-bold text-gray-900 mb-4" data-id="element-444">Owner's Equity</h2>
        <div className="space-y-2" data-id="element-445">
          <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-446">
            <span className="text-gray-700" data-id="element-447">Retained Earnings</span>
            <span className="font-medium text-gray-900" data-id="element-448">
              {formatCurrency(totalEquity * 0.7)}
            </span>
          </div>
          <div className="flex justify-between items-center py-2 border-b border-gray-100" data-id="element-449">
            <span className="text-gray-700" data-id="element-450">Current Year Earnings</span>
            <span className="font-medium text-gray-900" data-id="element-451">
              {formatCurrency(totalEquity * 0.3)}
            </span>
          </div>
        </div>
        <div className="pt-4 border-t-2 border-gray-300" data-id="element-452">
          <div className="flex justify-between items-center" data-id="element-453">
            <span className="text-lg font-bold text-gray-900" data-id="element-454">
              Total Equity
            </span>
            <span className="text-lg font-bold text-green-600" data-id="element-455">
              {formatCurrency(totalEquity)}
            </span>
          </div>
        </div>
      </Card>

      {/* Summary */}
      <Card className="bg-gray-50" data-id="element-456">
        <div className="flex justify-between items-center" data-id="element-457">
          <span className="text-xl font-bold text-gray-900" data-id="element-458">
            Total Liabilities + Equity
          </span>
          <span className="text-xl font-bold text-blue-600" data-id="element-459">
            {formatCurrency(totalLiabilities + totalEquity)}
          </span>
        </div>
        <p className="text-xs text-gray-500 mt-2" data-id="element-460">
          Should equal Total Assets: {formatCurrency(totalAssets)}
        </p>
      </Card>
    </div>;
}